module.exports = __webpack_public_path__ + "static/media/customertimes.7383623a.svg";